export const dayOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
